export type ResolveNavigationDecision =
  | { readonly action: "go_contract_list"; readonly message: string; readonly tone: "info" | "error" }
  | { readonly action: "go_review_summary"; readonly contractId: string };

const normalizeStatus = (s: string): string => s.trim().toLowerCase();

export function isAiInProgressStatus(status: string): boolean {
  const n = normalizeStatus(status);
  return n === "ai-inprogress" || n === "ai_in_progress";
}

export function decideResolveNavigation(input: {
  status: string;
  contractId: string;
}): ResolveNavigationDecision {
  if (isAiInProgressStatus(input.status)) {
    return {
      action: "go_contract_list",
      tone: "info",
      message: "AI processing is still running for this contract. Please refresh the list in a few minutes."
    };
  }
  return { action: "go_review_summary", contractId: input.contractId };
}
